<template>
    <div class="internship-agreement">
        <h4 class="title">{{ $t('internship.internship_agreement') }}</h4>
        <div class="description">&nbsp;</div>

        <div
            class="internship-agreement-file"
            v-if="internshipAgreementIn">
            Ongetekende overeenkomst vanuit school:
            <b-button
                class="btn-download btn-download-agreement"
                variant="primary"
                @click="downloadFile(internshipAgreementIn.file.path)">
                {{ $t('internship.download_unsigned_contract') }}
            </b-button>
        </div>

        <b-form-group
            class="internship-signed-agreement-file-name"
            label-for="signed-internship-name-input"
            :label="$t('internship.upload_signed_contract')">
            <b-form-input
                id="signed-internship-name-input"
                v-model="signedInternshipAgreementNewName"
                :placeholder="$t('internship.contract_from')">
            </b-form-input>

            <div class="internship-agreement-control">
                <div class="internship-agreement-upload">
                    <b-button
                        class="btn-upload btn-upload-banner"
                        variant="outline-primary"
                        @click="$refs.agreementUpload.$el.childNodes[0].click()">
                        {{ $t('internship.upload_contract') }}
                    </b-button>

                    <b-form-file
                        id="internships-agreement"
                        v-model="file"
                        v-show="false"
                        :placeholder="'file'"
                        ref="agreementUpload"
                        @input="updateAgreementFileName">
                    </b-form-file>
                </div>

                <b-button
                    class="btn-save btn-save-school-settings"
                    variant="primary"
                    @click="save">
                    {{ $t('common.save') }}
                </b-button>
            </div>
        </b-form-group>

        <ul class="signed-internship-agreement-list">
            <li
                class="signed-internship-agreement"
                v-for="signedInternshipAgreement in signedInternshipAgreements">
                {{ signedInternshipAgreement.file.name }}
                <div class="signed-internship-agreement-actions">
                    <b-button
                        class="btn-download btn-download-signed-agreement"
                        variant="primary-icon-only"
                        @click="downloadFile(signedInternshipAgreement.file.path)">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-signed-agreement"
                        v-if="signedInternshipAgreements.length > 1"
                        variant="danger-icon-only"
                        @click="deleteAgreement(signedInternshipAgreement)">
                    </b-button>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'design-2021-internship-report-signed-internship-agreement-upload-component',
    props: ['projectIn', 'internshipAgreementIn'],
    data() {
        return {
            signedInternshipAgreementNewName: this.projectIn.signed_internship_agreement?.file?.name ?? '',
            signedInternshipAgreements: this.projectIn.signed_internship_agreements,
            file: null,
        };
    },

    methods: {
        save() {
            const formData = new FormData();
            formData.append('signedInternshipAgreementName', this.signedInternshipAgreementNewName);
            formData.append('file', this.file);
            this.alert.saving();

            axios.post(this.routes.studentSignedInternshipAgreementUpload(this.projectIn.id), formData).then(
                (response) => {
                    this.alert.success();
                    this.signedInternshipAgreements.push(response.data);
                    this.$emit('internship-agreement-stored', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateAgreementFileName(file) {
            if (file === null || this.signedInternshipAgreementNewName.length > 0) {
                return;
            }

            const idx = file.name.lastIndexOf('.');
            this.signedInternshipAgreementNewName = file.name.slice(0, idx);
        },

        downloadFile(url) {
            window.open(url, '_blank');
        },
        deleteAgreement(agreement) {
            //Todo: make dynamic language
            this.alert
                .confirm(
                    this.$t('common.delete'),
                    this.$t('internship.confirm_signed_contract_deletion'),
                    this.$t('common.delete'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        this.axios
                            .delete(this.routes.studentSignedInternshipAgreementDelete(agreement.id))
                            .then((response) => {
                                this.signedInternshipAgreements = this.signedInternshipAgreements.filter(
                                    (signed) => signed.id !== agreement.id,
                                );
                                this.alert.success();
                            });
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss">
.internship-agreement {
    input {
        margin-bottom: 0;
    }

    .description {
        color: $text-muted-color;
        font-weight: $font-weight-medium;
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .internship-agreement-file,
    .signed-internship-agreement {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .agreement-file {
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');

        .internship-agreement-file-name ::v-deep {
            margin-bottom: 0;

            > div {
                display: flex;
                justify-content: flex-start;
                border-radius: 12px;

                &:focus-within {
                    box-shadow: 0 0 0 0.2rem rgba($primary, 25%);
                }
            }

            input {
                margin: 0;
                padding-top: map-get($grid-padding-spacing, 'ten');
                padding-bottom: map-get($grid-padding-spacing, 'ten');
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;

                &:focus {
                    box-shadow: none;
                }
            }

            .btn-file-download {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                border-top-right-radius: 12px;
                border-bottom-right-radius: 12px;

                &:before {
                    margin-right: 0;
                }
            }
        }
    }
}

.internship-agreement-control {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');

    .internship-agreement-upload {
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    }

    .internship-agreement-upload,
    .internship-agreement-upload .btn-upload,
    .btn-save-school-settings {
        width: 100%;
    }
}

.btn-download-signed-agreement,
.btn-download-agreement {
    margin-top: map-get($grid-gutter-spacing, 'ten');
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}
.signed-internship-agreement-list {
    list-style: none;
    padding-left: 0;
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
    .signed-internship-agreement {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        column-gap: map-get($grid-gutter-spacing, 'fifteen');
    }
    .signed-internship-agreement-actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        column-gap: map-get($grid-gutter-spacing, 'eight');
        margin-left: auto;
        .btn {
            margin: 0;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .internship-agreement-control {
        flex-direction: row;
        column-gap: $grid-gutter-width;

        .internship-agreement-upload {
            margin-bottom: 0;
        }

        .btn-save-school-settings {
            margin-bottom: 0;
        }

        .internship-agreement-upload,
        .internship-agreement-upload .btn-upload,
        .btn-save-school-settings {
            width: auto;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .internship-agreement-control {
        flex-direction: row;
        align-items: center;

        .internship-agreement-upload {
            margin-bottom: 0;
        }
    }
}
</style>
